"use client";
import {
  type NotificationData,
  type NotificationsProps,
  notifications,
} from "@mantine/notifications";

type NotificationType = "info" | "caution" | "error";

type Props = {
  type: NotificationType;
} & NotificationsProps &
  NotificationData;

function notificationId(type: NotificationType) {
  return type === "error"
    ? "error-notification"
    : type === "caution"
      ? "caution-notification"
      : "info-notification";
}

export function showNotification(props: Props) {
  const { type, ...option } = props;
  const color =
    type === "error" ? "red" : type === "caution" ? "orange" : "blue";
  notifications.show({ ...option, color: color, id: notificationId(type) });
}

// 同じ種類の通知は表示中だと後から出したものが捨てられるため、続けて出したいときに使う
export function hideNotification(type: NotificationType) {
  notifications.hide(notificationId(type));
}
